<template>
  <div class="w-1/5 uppercase text-xs border-r">
    <div
      class="border-b"
      :class="{ 'border-b bg-gray-600 text-white': name === 'dashboard' }"
    >
      <div
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': (name === 'auctions' || name.startsWith('auction') || name === 'lots' || name.startsWith('lot')) || name === 'lots_summary' || name === 'redistribute_lots_summary' && !name.startsWith('auction_calendar') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/aste"
        >
          <ChatBubbleBottomCenterIcon class="h-4 w-4 inline-block mr-2" />
          Aste
        </RouterLink>
      </div>
      <div
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'auction_calendars' || name.startsWith('auction_calendar') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/calendario-aste"
        >
          <CalendarIcon class="h-4 w-4 inline-block mr-2" />
          Calendario Aste
        </RouterLink>
      </div>
      <div
        v-if="authStore.isAdmin"
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'users' || name.startsWith('user') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/utenti"
        >
          <UserIcon class="h-4 w-4 inline-block mr-2" />
          Utenti
        </RouterLink>
      </div>
      <div
        v-if="authStore.isAdmin"
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'companies' || name.startsWith('company') && !name.startsWith('company_group') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/partecipanti"
        >
          <HomeModernIcon class="h-4 w-4 inline-block mr-2" />
          Partecipanti
        </RouterLink>
      </div>
      <div
        v-if="authStore.isAdmin"
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'bottlers' || name.startsWith('bottler') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/imbottigliatori"
        >
          <LightBulbIcon class="h-4 w-4 inline-block mr-2" />
          Imbottigliatori
        </RouterLink>
      </div>
      <div
        v-if="authStore.isAdmin"
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'company_groups' || name.startsWith('company_group') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/gruppi-partecipanti"
        >
          <RectangleGroupIcon class="h-4 w-4 inline-block mr-2" />
          Gruppi di Partecipanti
        </RouterLink>
      </div>
      <div
        v-if="authStore.isAdmin"
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'affiliates' || name.startsWith('affiliate') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/accreditati"
        >
          <LifebuoyIcon class="h-4 w-4 inline-block mr-2" />
          Accreditati
        </RouterLink>
      </div>
      <div
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'selection_sites' || name.startsWith('selection_site') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/centri-selezione"
        >
          <WalletIcon class="h-4 w-4 inline-block mr-2" />
          Centri di Selezione
        </RouterLink>
      </div>
      <div
        v-if="authStore.canManageAdmin"
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'admins' || name.startsWith('admin') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/amministratori"
        >
          <AcademicCapIcon class="h-4 w-4 inline-block mr-2" />
          Amministratori
        </RouterLink>
      </div>
      <div
        v-if="authStore.canManageUser"
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'viewers' || name.startsWith('viewer') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/visualizzatori"
        >
          <EyeIcon class="h-4 w-4 inline-block mr-2" />
          Visualizzatori
        </RouterLink>
      </div>
      <div
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'waste_codes' || name.startsWith('waste_code') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/codici-rifiuto"
        >
          <ArrowPathRoundedSquareIcon class="h-4 w-4 inline-block mr-2" />
          Codici Rifiuti
        </RouterLink>
      </div>
      <div
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'products' || name.startsWith('product') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/prodotti"
        >
          <PuzzlePieceIcon class="h-4 w-4 inline-block mr-2" />
          Prodotti
        </RouterLink>
      </div>
      <div
        class="border-b"
        :class="{ 'border-b bg-gray-600 text-white': name === 'categories' || name.startsWith('category') }"
      >
        <RouterLink
          class="block hover:bg-gray-400 hover:text-white p-2"
          to="/categorie"
        >
          <Square3Stack3DIcon class="h-4 w-4 inline-block mr-2" />
          Categorie
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  AcademicCapIcon, ArrowPathRoundedSquareIcon, CalendarIcon,
  ChatBubbleBottomCenterIcon, EyeIcon, HomeModernIcon,   LifebuoyIcon, LightBulbIcon,
  PuzzlePieceIcon,
  RectangleGroupIcon,   Square3Stack3DIcon, UserIcon, WalletIcon} from '@heroicons/vue/24/outline'
import { useRoute } from 'vue-router';

import { useAuthStore } from '@/stores/auth';

const { name } = useRoute()
const authStore = useAuthStore()

</script>